/* Обща форма за доставка на Domivo (09.10.2026) - snippets/domivo-delivery.liquid.
   1. Хваща "Преминаване към плащане" (количка и чекмедже - един и същ бутон
      name="checkout") и отваря формата.
   2. Еконт офиси/Еконтомати - от ERP-то (bg5.site/api/delivery/points),
      BOX NOW - официалната им карта (widget-cdn.boxnow.bg), адрес - градове
      от ERP-то.
   3. "Продължи": изборът отива в количката (атрибут _dmv_delivery - чете го
      ERP-то за товарителницата), после /checkout с попълнени имейл, име,
      телефон и адрес. Данните на клиента се помнят в localStorage. */
(() => {
  const API = 'https://bg5.site/api/delivery';
  const KEY = 'dmv-delivery-v1';
  const PER = 5;
  const FREE_FROM = 100;   // безплатна доставка над 100 € (тарифите в Shopify, 09.10.2026)
  let cartTotal = 0;
  const dlg = document.getElementById('dmv-delivery');
  if (!dlg || dlg.dataset.ready) return;
  dlg.dataset.ready = '1';
  const form = dlg.querySelector('form');
  const $ = (s) => dlg.querySelector(s);
  const F = (n) => form.elements[n];
  const listEl = $('[data-dl-list]');
  const err = $('[data-dl-err]');
  const st = { way: null, point: null, bn: null, page: 1, total: 0, lat: null, lng: null, q: '', t: 0 };
  let passing = false;

  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const save = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* частен режим */ } };

  // ---------------------------------------------------------------- измерване (12.10.2026)
  // Всяка стъпка отива (1) анонимно в ERP-то (sendBeacon, всички посетители,
  // без лични данни - случаен номер на сесията) и (2) в GA4 през dmvTrack ->
  // пиксела, само при прието съгласие. Стъпки: open, way, point, error,
  // submit, done, fallback, fail, close.
  let sid = '';
  try {
    sid = sessionStorage.getItem('dmv-dl-sid') || '';
    if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('dmv-dl-sid', sid); }
  } catch (e) { sid = Math.random().toString(36).slice(2); }
  let lastStep = '';
  let isOpen = false;
  let cartItems = 0;
  let cartLines = [];
  // ---------------------------------------------------------------- изоставени поръчки (15.10.2026)
  // Собственикът: "със сигурност да се записват, за да се опитваме да ги
  // спасяваме". Щом има валиден телефон или имейл, името/контактите и
  // количката отиват в ERP-то (Търговия > Изоставени поръчки). Под полетата
  // има видим ред, че ги пазим. Същото съдържание не се праща два пъти.
  let leadSent = '';
  let leadTimer;
  function lead() {
    const phone = phoneNorm(F('phone').value);
    const email = F('email').value.trim();
    const okPhone = /^\+\d{9,15}$/.test(phone);
    const okEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
    if (!okPhone && !okEmail) return;
    const p = st.point ? `${st.point.name || ''}${st.point.city ? ', ' + st.point.city : ''}` : (st.bn ? (st.bn.name || '') : '');
    const d = { sid, name: F('name').value.trim(), phone: okPhone ? phone : '', email: okEmail ? email : '',
      total: cartTotal, items: cartItems, lines: cartLines, way: st.way, point: p, mobile };
    const key = JSON.stringify(d);
    Object.assign(d, mktInfo());
    if (key === leadSent) return;
    leadSent = key;
    try { navigator.sendBeacon(`${API}/lead`, JSON.stringify(d)); } catch (e) { /* записът не пречи на формата */ }
  }
  function leadSoon() { clearTimeout(leadTimer); leadTimer = setTimeout(lead, 1200); }
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  // Meta Conversions API (15.10.2026): ERP-то праща "започнал поръчка" на Meta
  // само ако посетителят е приел маркетинговите бисквитки (Shopify Customer Privacy).
  function mktInfo() {
    let ok = false;
    try { ok = !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed && Shopify.customerPrivacy.marketingAllowed()); } catch (e) { ok = false; }
    if (!ok) return { mkt: false };
    const ck = (n) => { const m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; };
    // 16.10.2026: повече данни за съвпадение - постоянният идентификатор на
    // браузъра от Shopify, градът/пощенският код и продуктите в количката
    const city = (st.point && st.point.city) || F('city').value.trim();
    const zip = (st.point && st.point.zip) || F('zip').value.trim();
    return { mkt: true, fbp: ck('_fbp'), fbc: ck('_fbc'), ext: ck('_shopify_y'), url: location.href.split('#')[0],
      city, zip: /^\d{4}$/.test(zip) ? zip : '', lines: cartLines };
  }
  // при отваряне полетата често са попълнени от предишно посещение
  function knownContact() {
    const phone = phoneNorm(F('phone').value);
    const email = F('email').value.trim();
    return { name: F('name').value.trim(), phone: /^\+\d{9,15}$/.test(phone) ? phone : '',
      email: /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) ? email : '' };
  }
  function ev(step, extra) {
    const m = step === 'open' ? mktInfo() : {};
    const d = { sid, step, way: st.way, total: cartTotal, items: cartItems, mobile, ...m, ...(m.mkt ? knownContact() : {}), ...(extra || {}) };
    if (step !== 'close') lastStep = step;
    try { navigator.sendBeacon(`${API}/event`, JSON.stringify(d)); } catch (e) { /* без броене */ }
    if (window.dmvTrack) window.dmvTrack(`delivery_${step}`, { delivery_way: d.way || undefined, detail: d.detail || undefined, value: cartTotal || undefined, currency: 'EUR' });
  }

  // ---------------------------------------------------------------- отваряне
  function open() {
    const s = load();
    if (s) {
      ['name', 'phone', 'email', 'city', 'zip', 'street'].forEach((k) => { if (s[k] && !F(k).value) F(k).value = s[k]; });
      if (s.point) st.point = s.point;
      if (s.bn) st.bn = s.bn;
      // по подразбиране офис на Еконт; адресът не се избира сам (13.10.2026)
      if (s.way && s.way !== 'econt-address') setWay(s.way);
    }
    if (!st.way) setWay('econt-office');
    hideErr();
    lastStep = '';
    isOpen = true;
    prices().then(() => ev('open'));
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  // затворена без продължаване - веднъж, от бутона или от самия диалог (Esc, фон)
  function closedEv() {
    if (!isOpen || passing) return;
    isOpen = false;
    clearTimeout(leadTimer); lead();
    ev('close', { detail: lastStep });
  }
  function close() {
    closedEv();
    if (dlg.open) dlg.close();
    document.documentElement.style.overflow = '';
  }
  // Пази данните още докато се пишат - затворена форма или друга страница не ги губи
  const FIELDS = ['name', 'phone', 'email', 'city', 'zip', 'street'];
  function remember() {
    const s = load() || {};
    FIELDS.forEach((k) => { s[k] = F(k).value.trim(); });
    s.way = st.way;
    if (st.point) s.point = st.point;
    if (st.bn) s.bn = { ...st.bn, raw: undefined };
    save(s);
  }
  let rTimer;
  form.addEventListener('input', (e) => {
    if (!FIELDS.includes(e.target.name)) return;
    clearTimeout(rTimer);
    rTimer = setTimeout(remember, 300);
    leadSoon();
  });
  dlg.addEventListener('close', () => {
    document.documentElement.style.overflow = '';
    remember();
    closedEv();
  });
  $('[data-dl-close]').addEventListener('click', close);
  dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });

  function intercept(e) {
    if (passing) return;
    const b = e.target.closest && e.target.closest('button[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
    if (!b || b.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }
  document.addEventListener('click', intercept, true);
  document.addEventListener('submit', (e) => {
    if (passing || !e.submitter || e.submitter.name !== 'checkout') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // ---------------------------------------------------------------- цени
  async function prices() {
    try {
      const c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      cartTotal = (c.total_price || 0) / 100;
      cartItems = c.item_count || 0;
      cartLines = (c.items || []).map((i) => ({ variant_id: i.variant_id, title: i.title, qty: i.quantity,
        price: ((i.final_line_price || 0) / 100).toFixed(2) }));
      lockerFit(c.items || []);
    } catch (e) { /* остават без цена */ }
    const free = cartTotal >= FREE_FROM;
    dlg.querySelectorAll('[data-price]').forEach((el) => {
      el.textContent = free ? 'безплатно' : `${Number(el.dataset.price).toFixed(2).replace('.', ',')} €`;
      el.classList.toggle('is-free', free);
    });
    note();
  }
  // ---------------------------------------------------------------- автомати (13.10.2026)
  // Голям или тежък продукт не влиза в Еконтомат / BOX NOW (60x45x36 см, 20 кг) -
  // ERP-то знае размерите; тогава автоматите са сиви и формата минава на офис.
  async function lockerFit(items) {
    let ok = true;
    try {
      const r = await fetch(`${API}/fit`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map((i) => ({ variant_id: i.variant_id, quantity: i.quantity })) }) });
      ok = (await r.json()).locker !== false;
    } catch (e) { ok = true; }
    ['econt-machine', 'boxnow'].forEach((w) => {
      const inp = form.querySelector(`input[name="way"][value="${w}"]`);
      if (!inp) return;
      const lab = inp.closest('label');
      const sub = lab && lab.querySelector('.dmv-dl__way-s');
      inp.disabled = !ok;
      if (lab) lab.classList.toggle('is-off', !ok);
      if (sub) { sub.dataset.t = sub.dataset.t || sub.textContent; sub.textContent = ok ? sub.dataset.t : 'голямо за автомат'; }
    });
    if (!ok && (st.way === 'econt-machine' || st.way === 'boxnow')) { st.point = null; st.bn = null; setWay('econt-office'); }
  }

  // Shopify избира най-евтината тарифа сам - при офис/адрес казваме коя да изберат
  function note() {
    const n = $('[data-dl-note]');
    const office = st.way === 'econt-office' || st.way === 'econt-address';
    n.hidden = true;   // с черновата доставката в чекаута е точно избраната - подсказка не трябва
    void office;
    if (!n.hidden) n.textContent = 'В плащането изберете „Еконт - до офис или адрес“ (3,99 €).';
  }

  // ---------------------------------------------------------------- начин
  function setWay(way) {
    st.way = way;
    const r = form.querySelector(`input[name="way"][value="${way}"]`);
    if (r) r.checked = true;
    const pane = way === 'boxnow' ? 'boxnow' : way === 'econt-address' ? 'address' : 'points';
    dlg.querySelectorAll('[data-pane]').forEach((p) => { p.hidden = p.dataset.pane !== pane; });
    if (pane === 'points') {
      if (st.point && st.point.kind !== kindOf(way)) st.point = null;
      if (!F('q').value && F('city').value) F('q').value = F('city').value;
      st.page = 1;
      fetchPoints();
    }
    if (pane === 'boxnow') boxnow();
    note();
  }
  const kindOf = (way) => (way === 'econt-machine' ? 'machine' : 'office');
  form.addEventListener('change', (e) => { if (e.target.name === 'way') { hideErr(); setWay(e.target.value); ev('way'); } });

  // ---------------------------------------------------------------- пунктове на Еконт
  async function fetchPoints() {
    const t = ++st.t;
    const p = new URLSearchParams({ carrier: 'econt', kind: kindOf(st.way), q: F('q').value.trim(), page: st.page, per: PER });
    if (st.lat != null) { p.set('lat', st.lat); p.set('lng', st.lng); }
    listEl.innerHTML = '<li class="dmv-dl__none">Зареждане...</li>';
    try {
      const r = await fetch(`${API}/points?${p}`);
      const d = await r.json();
      if (t !== st.t) return;
      st.total = d.total;
      render(d.items);
    } catch (e) {
      if (t === st.t) listEl.innerHTML = '<li class="dmv-dl__none">Списъкът не се зареди. Проверете връзката и опитайте пак.</li>';
    }
  }
  function render(items) {
    const pager = $('[data-dl-pager]');
    if (!items.length) {
      listEl.innerHTML = '<li class="dmv-dl__none">Няма пункт по това търсене. Опитайте с името на града.</li>';
      pager.hidden = true;
      return;
    }
    listEl.innerHTML = items.map((i) => `
      <li class="dmv-dl__pt${st.point && st.point.code === i.code ? ' is-on' : ''}" data-code="${esc(i.code)}" tabindex="0">
        <b>${esc(i.kind === 'machine' ? 'Еконтомат' : 'Офис')}: ${esc(i.name)}</b>
        ${i.km != null ? `<span>${i.km < 10 ? i.km.toFixed(2) : Math.round(i.km)} км</span>` : ''}
        <small>${esc(i.address || i.city || '')}</small>
      </li>`).join('');
    listEl._items = items;
    const from = (st.page - 1) * PER + 1;
    $('[data-dl-count]').textContent = `${from}-${Math.min(st.total, st.page * PER)} от ${st.total} пункта`;
    $('[data-dl-prev]').disabled = st.page <= 1;
    $('[data-dl-next]').disabled = st.page * PER >= st.total;
    pager.hidden = st.total <= PER;
  }
  function pick(li) {
    const i = (listEl._items || []).find((x) => x.code === li.dataset.code);
    if (!i) return;
    st.point = { carrier: 'econt', kind: i.kind, code: i.code, name: i.name, city: i.city, zip: i.zip, address: i.address };
    listEl.querySelectorAll('.dmv-dl__pt').forEach((x) => x.classList.toggle('is-on', x === li));
    hideErr();
    ev('point', { detail: i.kind });
    leadSoon();
  }
  listEl.addEventListener('click', (e) => { const li = e.target.closest('.dmv-dl__pt'); if (li) pick(li); });
  listEl.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.classList.contains('dmv-dl__pt')) { e.preventDefault(); pick(e.target); } });
  let qTimer;
  F('q').addEventListener('input', () => { clearTimeout(qTimer); qTimer = setTimeout(() => { st.page = 1; fetchPoints(); }, 250); });
  F('q').addEventListener('keydown', (e) => { if (e.key === 'Enter') e.preventDefault(); });
  $('[data-dl-prev]').addEventListener('click', () => { st.page -= 1; fetchPoints(); });
  $('[data-dl-next]').addEventListener('click', () => { st.page += 1; fetchPoints(); });
  $('[data-dl-near]').addEventListener('click', () => {
    if (!navigator.geolocation) return showErr('Браузърът не дава местоположение - напишете града.');
    navigator.geolocation.getCurrentPosition((pos) => {
      st.lat = pos.coords.latitude; st.lng = pos.coords.longitude;
      F('q').value = ''; st.page = 1; fetchPoints();
    }, () => showErr('Няма разрешение за местоположение - напишете града.'), { timeout: 8000, maximumAge: 600000 });
  });

  // ---------------------------------------------------------------- BOX NOW
  function bnLabel(b) {
    return `<b>Автомат BOX NOW: ${esc(b.name || b.id)}</b>${esc([b.address, b.zip].filter(Boolean).join(', '))}`;
  }
  function boxnow() {
    const picked = $('[data-dl-bn-picked]');
    if (st.bn) { picked.innerHTML = bnLabel(st.bn); picked.hidden = false; }
    if (dlg.dataset.bn) return;
    dlg.dataset.bn = '1';
    window._bn_map_widget_config = {
      parentElement: '#dmv-bn-map',
      type: 'iframe',
      autoshow: true,       // без бутон - картата се показва веднага
      gps: true,
      autoclose: false,
      afterSelect(d) {
        const id = d.boxnowLockerId || d.lockerId || d.locker_id || d.id;
        if (!id) return;
        st.bn = {
          carrier: 'boxnow', kind: 'locker', code: String(id),
          name: d.boxnowLockerName || d.name || '',
          address: d.boxnowLockerAddressLine1 || d.addressLine1 || '',
          city: d.boxnowLockerAddressLine2 || d.city || '',
          zip: d.boxnowLockerPostalCode || d.postalCode || '',
          raw: d,
        };
        picked.innerHTML = bnLabel(st.bn);
        picked.hidden = false;
        hideErr();
        ev('point', { detail: 'boxnow' });
      },
    };
    const s = document.createElement('script');
    s.src = 'https://widget-cdn.boxnow.bg/map-widget/client/v4.js';
    s.async = true;
    document.head.appendChild(s);
  }

  // ---------------------------------------------------------------- градове (адрес)
  const sug = $('[data-dl-cities]');
  let cTimer;
  F('city').addEventListener('input', () => {
    clearTimeout(cTimer);
    const q = F('city').value.trim();
    if (q.length < 2) { sug.hidden = true; return; }
    cTimer = setTimeout(async () => {
      try {
        const d = await (await fetch(`${API}/cities?q=${encodeURIComponent(q)}`)).json();
        sug.innerHTML = d.items.map((c) => `<li data-n="${esc(c.name)}" data-z="${esc(c.zip)}">${esc(c.name)} <small>${esc(c.zip)}${c.region ? ', обл. ' + esc(c.region) : ''}${c.door === false ? ' · само до офис' : ''}</small></li>`).join('');
        sug.hidden = !d.items.length;
      } catch (e) { sug.hidden = true; }
    }, 200);
  });
  sug.addEventListener('mousedown', (e) => {
    const li = e.target.closest('li');
    if (!li) return;
    e.preventDefault();
    F('city').value = li.dataset.n;
    if (li.dataset.z) F('zip').value = li.dataset.z;
    sug.hidden = true;
    checkDoor();
  });
  F('city').addEventListener('blur', () => setTimeout(() => { sug.hidden = true; }, 150));

  // ---------------------------------------------------------------- до адрес само където Еконт разнася (13.10.2026)
  // Еконт вече доставя до врата в ~930 места; в останалите села пратката е само
  // до офис. Казваме го веднага и предлагаме най-близките офиси с един клик.
  const doorBox = $('[data-dl-door]');
  st.door = null;
  let dTimer;
  function doorReset() { st.door = null; if (doorBox) doorBox.hidden = true; }
  async function checkDoor() {
    const city = F('city').value.trim();
    const zip = F('zip').value.trim();
    if (!doorBox || !city || !/^\d{4}$/.test(zip)) { doorReset(); return; }
    try {
      const d = await (await fetch(`${API}/door?city=${encodeURIComponent(city)}&zip=${encodeURIComponent(zip)}`)).json();
      if (F('city').value.trim() !== city || F('zip').value.trim() !== zip) return;
      st.door = d;
      if (d.door !== false) { doorBox.hidden = true; return; }
      const offs = (d.offices || []).map((o, i) => `<button type="button" data-i="${i}"><b>Офис на Еконт: ${esc(o.name)}</b><small>${esc(o.address || o.city || '')}</small></button>`).join('');
      doorBox.innerHTML = `<b>До адрес в ${esc(d.place || city)} не доставяме.</b> Там пратките са само до офис${offs ? ' - изберете един от най-близките:' : '. Изберете офис отгоре („До офис на Еконт“).'}${offs ? `<div class="dmv-dl__door-offs">${offs}</div>` : ''}`;
      doorBox.hidden = false;
      doorBox._offs = d.offices || [];
      ev('error', { detail: 'no_door' });
    } catch (e) { doorReset(); }
  }
  if (doorBox) {
    doorBox.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-i]');
      if (!b) return;
      const o = doorBox._offs[+b.dataset.i];
      st.point = { carrier: 'econt', kind: 'office', code: o.code, name: o.name, city: o.city, zip: '', address: o.address };
      F('q').value = o.name;
      setWay('econt-office');
      hideErr();
      ev('point', { detail: 'office_from_door' });
    });
  }
  F('city').addEventListener('input', doorReset);
  ['city', 'zip'].forEach((n) => F(n).addEventListener('change', () => { clearTimeout(dTimer); dTimer = setTimeout(checkDoor, 150); }));

  // ---------------------------------------------------------------- проверка и плащане
  function showErr(m) { err.textContent = m; err.hidden = false; err.scrollIntoView({ block: 'nearest' }); }
  function hideErr() {
    err.hidden = true;
    form.querySelectorAll('.is-bad').forEach((x) => x.classList.remove('is-bad'));
    form.querySelectorAll('.dmv-dl__ferr').forEach((x) => x.remove());
  }
  /* 17.10.2026: грешката стои под самото поле. Досега фокусът отиваше на полето
     горе, а текстът - долу до бутона, и на телефон клиент с 347 EUR количка
     видя само червена лента без поле и затвори формата. */
  function bad(name, msg) {
    const f = F(name);
    f.classList.add('is-bad');
    const m = document.createElement('small');
    m.className = 'dmv-dl__ferr';
    m.textContent = msg;
    f.insertAdjacentElement('afterend', m);
    err.textContent = msg; err.hidden = false;
    f.focus({ preventScroll: true });
    f.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return false;
  }
  form.querySelector('[data-dl-code]')?.addEventListener('click', (e) => {
    e.currentTarget.hidden = true;
    const box = form.querySelector('[data-dl-codef]');
    box.hidden = false;
    F('code').focus();
  });
  /* "нямам", "няма", "не", "-"... в полето за код не е код (17.10.2026) */
  function codeValue() {
    const v = F('code').value.trim();
    return /^(n[iy]?qmam|n[iy]?ama|нямам|няма|не|no|none|nqma|-+|\.+|0+)$/i.test(v) ? '' : v;
  }
  /* 15.10.2026: клиент с количка 87 EUR се отказа след 5 x "Телефонът не
     изглежда верен" - приемаме и номер без нулата (888 123 456), с (0) след
     +359 и с плюс по средата. Отказваме само ако цифрите са явно малко/много. */
  function phoneNorm(v) {
    let d = v.replace(/[^\d+]/g, '');
    d = d.charAt(0) + d.slice(1).replace(/\+/g, '');
    if (d.startsWith('00')) d = '+' + d.slice(2);
    if (/^\+?3590/.test(d)) d = '+359' + d.replace(/^\+?3590/, '');
    if (d.startsWith('0')) d = '+359' + d.slice(1);
    if (/^359/.test(d)) d = '+' + d;
    if (/^[2-9]\d{6,8}$/.test(d)) d = '+359' + d;
    return d;
  }
  function splitName(full) {
    const parts = full.trim().split(/\s+/);
    return parts.length > 1 ? [parts.slice(0, -1).join(' '), parts[parts.length - 1]] : [parts[0], ''];
  }
  function validate() {
    hideErr();
    /* името: едно име също минава (13.10 клиент се отказа след 5 x "име и фамилия") */
    if (F('name').value.replace(/[^\p{L}]/gu, '').length < 2) return bad('name', 'Напишете името си.');
    if (!/^\+\d{9,15}$/.test(phoneNorm(F('phone').value))) return bad('phone', 'Напишете телефона си, например 0888 123 456.');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(F('email').value.trim())) return bad('email', 'Напишете имейл - там идва потвърждението.');
    if (st.way === 'boxnow' && !st.bn) { showErr('Изберете автомат от картата.'); return false; }
    if ((st.way === 'econt-office' || st.way === 'econt-machine') && !st.point) { showErr(st.way === 'econt-machine' ? 'Изберете Еконтомат от списъка.' : 'Изберете офис от списъка.'); return false; }
    if (st.way === 'econt-address') {
      if (!F('city').value.trim()) return bad('city', 'Напишете населеното място.');
      if (!/^\d{4}$/.test(F('zip').value.trim())) return bad('zip', 'Пощенският код е 4 цифри.');
      if (F('street').value.trim().length < 4) return bad('street', 'Напишете улица и номер.');
      if (st.door && st.door.door === false) { showErr(`До адрес в ${st.door.place || F('city').value.trim()} не доставяме. Изберете офис.`); return false; }
    }
    return true;
  }
  function delivery() {
    if (st.way === 'boxnow') {
      const b = st.bn;
      return { carrier: 'boxnow', kind: 'locker', code: b.code, name: b.name,
        address1: `Автомат BOX NOW [${b.code}] ${b.name}`.trim(), city: b.city || '', zip: b.zip || '' };
    }
    if (st.way === 'econt-address') {
      return { carrier: 'econt', kind: 'address', address1: F('street').value.trim(),
        city: F('city').value.trim(), zip: F('zip').value.trim() };
    }
    const p = st.point;
    const label = p.kind === 'machine' ? 'Еконтомат' : 'Офис на Еконт';
    return { carrier: 'econt', kind: p.kind, code: p.code, name: p.name,
      address1: `${label} [${p.code}] ${p.name}`, city: p.city || '', zip: p.zip || '' };
  }
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!validate()) { ev('error', { detail: err.textContent.slice(0, 80) }); clearTimeout(leadTimer); lead(); return; }
    ev('submit');
    const go = $('.dmv-dl__go');
    go.setAttribute('aria-busy', 'true');
    const d = delivery();
    const phone = phoneNorm(F('phone').value);
    const [first, last] = splitName(F('name').value);
    save({ name: F('name').value.trim(), phone: F('phone').value.trim(), email: F('email').value.trim(),
      city: F('city').value.trim(), zip: F('zip').value.trim(), street: F('street').value.trim(),
      way: st.way, point: st.point, bn: st.bn ? { ...st.bn, raw: undefined } : null });
    // 1) чернова с точната доставка (ERP); 2) при грешка в ERP-то - стария начин
    try {
      const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      const codes = [codeValue()].concat((cart.discount_codes || [])
        .filter((x) => x.applicable !== false).map((x) => x.code)).filter(Boolean);
      const ctl = new AbortController();
      const timer = setTimeout(() => ctl.abort(), 25000);   // ERP-то бави - стария начин
      const r = await fetch(`${API}/checkout`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctl.signal,
        body: JSON.stringify({
          lines: cart.items.map((i) => ({ variant_id: i.variant_id, quantity: i.quantity, properties: i.properties || {} })),
          delivery: { ...d, way: st.way },
          customer: { first, last, phone, email: F('email').value.trim() },
          discount_codes: [...new Set(codes)],
          attributes: cart.attributes || {},
          note: cart.note || '',
        }),
      });
      clearTimeout(timer);
      const out = await r.json().catch(() => ({}));
      if (r.ok && out.url) {
        ev('done', { detail: 'draft' });
        passing = true;
        window.dispatchEvent(new CustomEvent('dmv:delivery', { detail: { ...d, draft: out.draft } }));
        location.href = out.url;
        return;
      }
      if (r.status === 422 || r.status === 429) {
        ev('fail', { detail: `${r.status} ${out.error || ''}`.slice(0, 80) });
        go.removeAttribute('aria-busy');
        showErr(out.error || 'Проверете данните и опитайте пак.');
        return;
      }
    } catch (e3) { /* ERP-то не отговаря - продължаваме по стария начин */ }
    try {
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _dmv_delivery: JSON.stringify({ ...d, phone, way: st.way }) } }) });
    } catch (e2) { /* плащането пак ще тръгне - адресът е в него */ }
    const q = new URLSearchParams({
      'checkout[email]': F('email').value.trim(),
      'checkout[shipping_address][first_name]': first,
      'checkout[shipping_address][last_name]': last,
      'checkout[shipping_address][address1]': d.address1,
      'checkout[shipping_address][city]': d.city,
      'checkout[shipping_address][zip]': d.zip,
      'checkout[shipping_address][country]': 'BG',
      'checkout[shipping_address][phone]': phone,
    });
    ev('fallback');
    passing = true;
    window.dispatchEvent(new CustomEvent('dmv:delivery', { detail: d }));
    location.href = `/checkout?${q}`;
  });
})();
